var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdfDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u7EC4_20837",
    "data-name": "\\u7EC4 20837",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62_5567",
    "data-name": "\\u77E9\\u5F62 5567",
    width: 18,
    height: 24,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_20830",
    "data-name": "\\u7EC4 20830",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_248047",
    "data-name": "\\u8DEF\\u5F84 248047",
    d: "M23.873,43.106a1.982,1.982,0,0,0-.374.03v2.038h.345a.762.762,0,0,0,.719-.36,1.322,1.322,0,0,0,.172-.719C24.735,43.406,24.448,43.106,23.873,43.106Z",
    transform: "translate(-18.812 -34.144)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_248048",
    "data-name": "\\u8DEF\\u5F84 248048",
    d: "M11.186,43.106h-.23v.839c.029,0,.144.03.2.03.575,0,.633-.24.633-.45C11.79,43.406,11.79,43.106,11.186,43.106Z",
    transform: "translate(-8.771 -34.144)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_248049",
    "data-name": "\\u8DEF\\u5F84 248049",
    d: "M10.467,35.133A1.084,1.084,0,0,0,9.4,34.024H1.064A1.085,1.085,0,0,0,0,35.133v3.656A1.084,1.084,0,0,0,1.064,39.9H9.4a1.085,1.085,0,0,0,1.064-1.109Zm-7.16,2.008a1.478,1.478,0,0,1-.978.3H2.185V38.7H1.5V35.342l.144-.03a4.114,4.114,0,0,1,.805-.09,1.364,1.364,0,0,1,.92.27,1.009,1.009,0,0,1,.374.779A1.065,1.065,0,0,1,3.307,37.141Zm2.962.929a1.575,1.575,0,0,1-1.294.569c-.173,0-.431-.03-.805-.06l-.086-.03V35.343l.086-.03a8.52,8.52,0,0,1,.92-.09,1.448,1.448,0,0,1,1.208.51,1.68,1.68,0,0,1,.316,1.109A1.932,1.932,0,0,1,6.268,38.07Zm2.7-2.128H7.591v.629H8.856v.72H7.591V38.7H6.872V35.313h2.1Z",
    transform: "translate(0 -26.951)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_248050",
    "data-name": "\\u8DEF\\u5F84 248050",
    d: "M20.159,0V.03H12.482a1.083,1.083,0,0,0-1.093,1.079V6.5h.891V1.678A.727.727,0,0,1,13,.929h7.16V6.174a1.131,1.131,0,0,0,1.064,1.139h5.032V20.171a.727.727,0,0,1-.719.749H22.315c-.029.03-.029.06-.057.09l-.6.809h4.4a1.092,1.092,0,0,0,1.064-1.139V7.283Z",
    transform: "translate(-9.117)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_248051",
    "data-name": "\\u8DEF\\u5F84 248051",
    d: "M16.22,72.224H13a.727.727,0,0,1-.719-.749V64.731h-.891v7.253a1.116,1.116,0,0,0,1.093,1.139h4.4l-.6-.809C16.277,72.284,16.248,72.254,16.22,72.224Z",
    transform: "translate(-9.117 -51.274)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_248052",
    "data-name": "\\u8DEF\\u5F84 248052",
    d: "M42.6,79.757h-1.15V75.621a.491.491,0,0,0-.46-.51H39.553a.515.515,0,0,0-.489.51v4.136h-1.15a.283.283,0,0,0-.23.45l2.329,3.177a.291.291,0,0,0,.46,0L42.8,80.206a.266.266,0,0,0-.2-.45Z",
    transform: "translate(-30.122 -59.496)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfDownload);
export default __webpack_public_path__ + "static/media/PDFDownload.4db436832e9cb35db23946c2532dbb97.svg";
export { ForwardRef as ReactComponent };